export default function EAMsp() {
    return <iframe
        title="Показатели МСП"
        className="w-full"
        height={window.innerHeight - (window.innerHeight * 0.1)}
        src="https://app.powerbi.com/view?r=eyJrIjoiNjNjNWY1MzYtYmFiZC00ZWU4LWEwZDAtYzQ2ODE0NTA3NTIyIiwidCI6ImFlYzY0YzIyLTgzYjYtNGZmZS05N2VhLTk2NzdhZGUzZDRkMCIsImMiOjl9"
        frameBorder="0"
        allowFullScreen="true"
    />
}
